import React from 'react';
import { useTranslation } from 'react-i18next';

export default function NIS2SummaryContent() {
  const { t } = useTranslation();

  return (
    <div className="w-full max-w-lg p-6 bg-[#F3F4F7] rounded-md shadow-lg text-gray-800">
      {/* Titolo */}
      <h2 className="text-2xl font-bold mb-4">{t('nis2Summary.title')}</h2>

      {/* Testo introduttivo */}

      <div className="w-full text-gray-800">
        <p className="leading-relaxed text-sm sm:text-base">
          {t('nis2Summary.paragraph1')}
        </p>
      </div>

      {/* Nota aggiuntiva / conclusione */}
      <div className="text-sm mt-8">
        {t('nis2Summary.morePrefix', { defaultValue: 'Per approfondire, ' })}{' '}
        <a
          href="https://www.gazzettaufficiale.it/eli/id/2024/10/01/24G00155/SG"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline hover:text-blue-800 transition-colors"
        >
          {t('nis2Summary.moreLinkText')}
        </a>
      </div>
    </div>
  );
};

